// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"0349eb21","359":"16d0bd89","753":"42f69bf4","907":"5983ce4e","923":"532a9162"}[chunkId] + ".chunk.js";
};